var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshOneArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.112 13.5C2.836 18.311 6.987 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C7.9 2 4.375 4.468 2.832 8",
    stroke: "#2E2B63",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8H2.6C2.52121 8 2.44319 7.98448 2.37039 7.95433C2.29759 7.92417 2.23145 7.87998 2.17574 7.82426C2.12002 7.76855 2.07582 7.70241 2.04567 7.62961C2.01552 7.55681 2 7.47879 2 7.4V3",
    stroke: "#2E2B63",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshOneArrow);
export default __webpack_public_path__ + "static/media/refreshOneArrow.5e31311d8eb5d002145c76dd6bef0fc8.svg";
export { ForwardRef as ReactComponent };